import { render } from "./WindPowerStationView.vue?vue&type=template&id=3948a01c&scoped=true"
import script from "./WindPowerStationView.vue?vue&type=script&lang=js"
export * from "./WindPowerStationView.vue?vue&type=script&lang=js"

import "./WindPowerStationView.vue?vue&type=style&index=0&id=3948a01c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3948a01c"]])

export default __exports__